import { useEffect } from 'react'
import { Controller } from 'react-hook-form'

import type { AlertDetailsResponseType } from '@/api/types/Alert'
import Button from '@/elements/Button'
import Flex from '@/elements/Flex'
import Form from '@/elements/Form'
import Text from '@/elements/Text'
import useAlertCategoriesForm from '@/hooks/forms/useAlertCategoriesForm'
import FormToggle from '@/elements/FormToggle'
import RadioGroup from '@/elements/RadioGroup'
import Label from '@/elements/Label'

function AlertCategories({ alertCategoriesData, updateAlert }: {
  alertCategoriesData: Partial<AlertDetailsResponseType>
  updateAlert: (newData: any) => Promise<void>
}) {
  const { form, resetForm } = useAlertCategoriesForm(alertCategoriesData)

  useEffect(() => {
    resetForm(alertCategoriesData)
  }, [alertCategoriesData, resetForm])

  const handleSubmit = async (data: any) => {
    const body: Record<string, boolean> = {
      notMe: data.notMe
    }
    if (!data.notMe) {
      body['authorized'] = data.authorized
      body['threat'] = data.threat
    }
    await updateAlert(body)
    form.reset(data)
  }

  return (
    <Form onSubmit={form.handleSubmit(handleSubmit)}>
      <Controller
        name='notMe'
        control={form.control}
        render={({ field }) => (
          <Flex inline justify='space-between' wfull>
            <Flex wfull>
              <Text variant='h3'>Not Me</Text>
            </Flex>
            <FormToggle
              {...field}
              value={field.value}
              onChange={checked => {
                field.onChange(checked)
                if (checked) {
                  form.setValue('authorized', null)
                  form.setValue('threat', null)
                  form.clearErrors(['authorized', 'threat'])
                } else {
                  form.setValue('authorized', false)
                  form.setValue('threat', false)
                }
              }}
            />
          </Flex>
        )}
      />
      {!form.getValues('notMe') && (
        <Flex className='form-group'>
          <Controller
            name='authorized'
            control={form.control}
            render={({ field }) => (
              <Flex wfull>
                <Label>Authorized</Label>
                <RadioGroup
                  {...field}
                  yesOrNo
                  fullWidth
                  value={field.value === null ? undefined : field.value}
                  error={form.formState.errors.authorized?.message}
                  disabled={form.watch('notMe')}
                />
              </Flex>
            )}
          />
          <Controller
            name='threat'
            control={form.control}
            render={({ field }) => (
              <Flex wfull>
                <Label>Threat</Label>
                <RadioGroup
                  {...field}
                  yesOrNo
                  fullWidth
                  value={field.value === null ? undefined : field.value}
                  error={form.formState.errors.threat?.message}
                  disabled={form.watch('notMe')}
                />
              </Flex>
            )}
          />
        </Flex>
      )}
      <Button
        submit
        variant='accent'
        disabled={!form.formState.isDirty}
      >
        Save Changes
      </Button>
    </Form>
  )
}

export default AlertCategories
